// TravelDesk Plan 2b - the Excursions tab, the fourth search tab (D-21a)
export const NGXS_EXCURSIONS_PERSISTENT_STATE_KEYS: string[] = ['excursions.searchForm'];
export const NGXS_EXCURSIONS_SEARCH_FORM = 'excursions.searchForm';

/** The supplier's availability kinds as the core marks every loaded price (TravelDesk D-10); the filter of the tab. */
export const EXCURSION_KINDS = [
  { value: 'LiveBook', label: 'LiveBook', hint: 'instant confirmation' },
  { value: 'TicketOnly', label: 'TicketOnly', hint: 'open-dated tickets' },
  { value: 'OnRequest', label: 'OnRequest', hint: 'the supplier confirms later' }
];
